import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import SeoContent from './components/SeoContent';
import TrustSection from './components/TrustSection';
import FeaturedGuide from './components/FeaturedGuide';
import ArticleHighlights from './components/ArticleHighlights';
import CtaSection from './components/CtaSection';

const siteUrl = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.VITE_SITE_URL || 'https://sugargoosheet.site' : 'https://sugargoosheet.site';
const logoUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Sugargoo Spreadsheet',
  url: siteUrl,
  logo: logoUrl,
  description: 'Your ultimate independent resource for Sugargoo Spreadsheet discoveries, shopping guides, reviews, and expert tips.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Sugargoo Spreadsheet',
  url: siteUrl,
  description: 'Discover the best Sugargoo Spreadsheet with product finds, shopping guides, shipping costs, coupons, reviews and complete Sugargoo resources.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <SeoContent />
        <TrustSection />
        <FeaturedGuide />
        <ArticleHighlights />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}